import { useEffect, useRef, useState } from "react"
import { useMobile } from "lib/@components/mobile"
import { Button, InputAdornment, Stack, TextField } from "@mui/material"
import { setFromEvent } from "lib/setFromEvent"
import { SearchFor } from "event-definitions"
import Iconify from "minimals-template/components/Iconify"
import { clearSearchTerm } from "routes/facilities/plugins/helpers/use-clean-debounced-value"

export function SearchBox() {
    const [search, setSearch] = useState("")
    const ref = useRef()
    const isMobile = useMobile()
    useEffect(() => {
        setTimeout(() => {
            ref.current?.focus()
        }, 100)
    }, [])
    return (
        <Stack spacing={2} sx={{ width: 1, my: 4 }}>
            <TextField
                ref={ref}
                variant="outlined"
                autoFocus
                name="search"
                autoComplete="new-password"
                //changed to keyDown as keyUp was picking up keyUp events from keyboard clicks on previous pages.
                onKeyDown={(e) => e.key === "Enter" && go()}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <Button
                                onClick={go}
                                size="small"
                                sx={{ fontSize: 24 }}
                                color="primary"
                                variant="contained"
                                data-cy="schedule-search-submit-button"
                                aria-label="schedule search"
                            >
                                <Iconify icon="mdi:search" />
                            </Button>
                        </InputAdornment>
                    ),
                }}
                placeholder={isMobile ? "Search..." : "Search for words, or a Uniclass, SFG20 or NRM code..."}
                value={search}
                onChange={setFromEvent(setSearch)}
                fullWidth
                data-cy="schedule-library-searchbox"
            />
        </Stack>
    )

    function go() {
        const searchNoHash = clearSearchTerm(search)
        SearchFor.raise(searchNoHash)
    }
}
